module.exports = __webpack_public_path__ + "img/borderCubeWhite.a99f279e.svg";